export const environment = {
  "production":false,
  "baseHref":"/advanced-search/",
  "assessorUrl":"//www.douglas.co.us/assessor/",
  "detailUrl":"../web/#/details/",
  "envName":"ua",
  "capture":true,
  "deployDestination":"\\\\qaassr-prime\\C$\\inetpub\\wwwroot\\advancedsearch\\",
  "fileLocation":"//uaapps.douglas.co.us/realware/DOWNLOADS/",
  "dcportal":"https://apps.douglas.co.us/gisportal/",
  "assessorEmail":"assessors@douglas.co.us",
  "elasticReader":{
    "host":"//uaapps.douglas.co.us",
    "options":"/assessor/advanced-search-config/all",
    "search":"/assessor/account-query",
    "lookup":"/assessor/account-query?filter_path=aggregations",
    "count":"/assessor/account-query-count?filter_path=count",
    "sniffOnStart":true,
    "sniffInterval":60000,
    "pingConfig":{"requestTimeout":30000},
    "source":"config",
    "headers":{
      "Access-Control-Allow-Origin":"*",
      "Content-Type":"application/json"
    }
  }
};
